module.exports = __webpack_public_path__ + "img/vipps-logo-orange.fd2b940.png";